module.exports = __webpack_public_path__ + "static/media/compress-point.53fcb546.svg";